import React from 'react';
import {
  Box,
  Typography,
  Avatar,
  Stack,
  Divider,
  LinearProgress,
  Chip,
  alpha,
  useTheme
} from '@mui/material';
import { MUIChart } from '../styled/StyledComponents';

const ProgressChart = ({ data, title, subtitle, icon }) => {
  const theme = useTheme();
  const maxValue = Math.max(...data.map(item => item.value));
  
  return (
    <MUIChart elevation={3}>
      <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 3 }}>
        <Avatar sx={{ bgcolor: 'primary.main' }}>
          {icon}
        </Avatar>
        <Box>
          <Typography variant="h6" fontWeight="bold">{title}</Typography>
          <Typography variant="body2" color="text.secondary">{subtitle}</Typography>
        </Box>
      </Stack>
      <Divider sx={{ mb: 3 }} />
      <Stack spacing={2} sx={{ flexGrow: 1 }}>
        {data.map((item, index) => (
          <Box key={index}>
            <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 1 }}>
              <Typography variant="body2" fontWeight="medium">{item.label}</Typography>
              <Chip 
                label={`${item.value}${item.unit || ''}`} 
                size="small" 
                color="primary" 
                variant="outlined"
              />
            </Stack>
            <LinearProgress 
              variant="determinate" 
              value={(item.value / maxValue) * 100}
              sx={{ 
                height: 8, 
                borderRadius: 4,
                bgcolor: alpha(theme.palette.grey[500], 0.2),
                '& .MuiLinearProgress-bar': {
                  borderRadius: 4,
                  background: `linear-gradient(90deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`
                }
              }}
            />
          </Box>
        ))}
      </Stack>
    </MUIChart>
  );
};

export default ProgressChart; 